import { customElement, property } from 'lit/decorators.js';
import { html, LitElement } from 'lit';
import { styles } from '../view/styles';
import { FontSizes } from '../../../../../types/common/types';
import { translateFn } from '../../../../../utils/translator.helper';
import { EndpointTagWebComponent } from './EndpointTagWebComponent';
import { CustomRulesEvents } from '../../../../customRulesGrid/types';
import { isEmpty } from 'lodash';

/**
 * @summary Type here the description of this component
 * @tag selected-tags
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('selected-tags')
export class SelectedTagsWebComponent extends LitElement {
  @property({ type: Array, attribute: false, reflect: false })
  tags;

  @property({ type: Boolean })
  isPartnerCompany = false;

  @property({ type: Array, attribute: false, reflect: false })
  displayedTags: EndpointTagWebComponent[] = [];

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    this.displayedTags = [];
    for (const tag of this.tags) {
      const newTag = new EndpointTagWebComponent();
      newTag.isPartnerCompany = this.isPartnerCompany;
      newTag.tag = tag;
      newTag.addEventListener(CustomRulesEvents.DELETE, () => {
        this.handleDeleteTag(newTag);
      });
      this.displayedTags.push(newTag);
    }

    return html`<gz-text
        fontSize="${FontSizes.PARAGRAPH_11}"
        class="section-title text-uppercase mb-1 title-custom-align"
        fontWeight="500"
      >
        ${translateFn('Selected endpoint tags')}
      </gz-text>
      <div>${isEmpty(this.displayedTags) ? this.renderEmptyTags() : this.displayedTags}</div>`;
  }

  private renderEmptyTags() {
    return html`<gz-text class="empty-tags" fontSize="12" fontWeight="400"
      >${translateFn('No tags selected yet')}</gz-text
    >`;
  }

  private handleDeleteTag(tagComponent) {
    const index = this.displayedTags.indexOf(tagComponent);
    this.tags = this.tags.filter((tag, i) => i !== index);
    this.dispatchEvent(new CustomEvent(CustomRulesEvents.DELETE, { detail: tagComponent.tag }));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'selected-tags': SelectedTagsWebComponent;
  }
}
